<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="d-flex align-items-center justify-content-center mt-5 mb-10">
      <BaseIcon size="small">
        <AdvertiserIcon />
      </BaseIcon>
      <h1 class="text-uppercase mb-0 ms-5">
        {{ $t('advertisers') }}
      </h1>
    </div>
    <!-- ADVERTISERS -->
    <div class="mt-4">
      <AdvertiserListTable
        :reload="reload"
      />
    </div> <!-- END ADVERTISERS -->
  </MainLayout>
</template>

<script>

import { mapState } from 'vuex'

import AdvertiserIcon from '@/components/common/Icon/AdvertiserIcon'
import AdvertiserListTable from '@/components/advertisers/AdvertiserListTable'
import BaseIcon from '@/components/common/Icon/BaseIcon'
import MainLayout from '@/components/layouts/MainLayout'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

export default {
  components: {
    AdvertiserListTable,
    AdvertiserIcon,
    BaseIcon,
    MainLayout,
    Shortcuts
  },
  data () {
    return {
      reload: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('advertisers')
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Handle upsert
     */
    handleUpsert (advertiser) {
      this.$router.push({ name: 'advertisers.show', params: { id: advertiser.id } })
    },
    /**
     * Reload advertisers
     */
    reloadAdvertisers () {
      this.reload = true
      setTimeout(() => {
        this.reload = false
      }, 300)
    }
  }
}
</script>
